const { findBelfiore } = require('../belfioreLookup');
import jQuery from 'jquery';
import {checkVAT, countries} from 'jsvat';

window.CodiceFiscale = require('../codice_fiscale/codice-fiscale');

window.toastr = require('toastr');
require('select2');


if (typeof window.jQuery === 'undefined' || typeof window.$ === 'undefined') {
    window.jQuery = jQuery;
    window.$ = jQuery;
}
var $ = window.jQuery;

const Select2ItalianTranslation = require("select2/dist/js/i18n/it");
const toastrCss = require("toastr/build/toastr.min.css");

const helper = {
    updateKindInterface: function (value) {
        console.log('aggiorna interfaccia', value);
        if (value === 'company') {
            $('.field-companyname').removeClass('hidden');
        } else {
            $('.field-companyname').addClass('hidden');
            $('.field-companyname input').val("");
        }
        if (value === 'private') {
            $('.field-vat').addClass('hidden');
        } else {
            $('.field-vat').removeClass('hidden');
        }
    },
    retrieveCheckCF: function (name, surname, dob, country, city) {
        const belfiore = findBelfiore(window.belfioreList, country === 'IT' ? city : country);
        if (!belfiore) return [];


        let cfMaleFake = {
            name: name,
            surname: surname,
            gender: 'M',
            /*birthday: dob,*/
            birthplace: belfiore
        };
        let cfFemaleFake = {
            name: name,
            surname: surname,
            gender: 'F',
            /*birthday: dob,*/
            birthplace: belfiore
        };


        if (typeof dob === 'object' && typeof dob.getMonth === 'function') {
            cfMaleFake.day = dob.getDate();
            cfMaleFake.month = dob.getMonth() + 1;
            cfMaleFake.year = dob.getFullYear();

            cfFemaleFake.day = dob.getDate();
            cfFemaleFake.month = dob.getMonth() + 1;
            cfFemaleFake.year = dob.getFullYear();
        } else if (typeof dob === 'string') {
            cfMaleFake.birthday = dob;
            cfFemaleFake.birthday = dob;
        }

        console.log(cfFemaleFake);
        const _cfMaleFake = new CodiceFiscale.default(cfMaleFake);
        const _cfFemaleFake = new CodiceFiscale.default(cfFemaleFake);

        return [
            _cfMaleFake.toString(),
            _cfFemaleFake.toString()
        ];
    },
    validateCF: function (cf, name, surname, dob, country, city) {
        console.debug('richiesta convalida light di cf per ', cf, name, surname, dob, country, city);
        if (typeof cf === 'undefined') {
            return false;
        }
        if ((cf + "").length < 1) {
            return false;
        }
        if (typeof name === 'undefined') {
            console.log('Impossibile validare, name nullo')
            return true
        }
        if (typeof surname === 'undefined') {
            console.log('Impossibile validare, surname nullo')
            return true
        }
        if (typeof dob === 'undefined') {
            console.log('Impossibile validare, dob nullo')
            return true
        }
        if (typeof dob === 'string' && (dob + "").length < 1) {
            console.log('Impossibile validare, dob vuoto')
            return true
        }
        if (typeof dob === 'undefined' || dob === null) {
            console.log('Impossibile validare, dob vuoto')
            return true
        }
        if (typeof country === 'undefined') {
            console.log('Impossibile validare, country nullo')
            return true
        }
        if ((country + "").length < 1) {
            console.log('Impossibile validare, country vuoto')
            return true
        }
        /* old Great Britain Notation for belfiore list */
        if (country === 'GB') {
            country = 'UK';
        }
        if (country === "IT") {
            if (typeof city === 'undefined') {
                console.log('Impossibile validare, country nullo')
                return true
            }
            if ((city + "").length < 1) {
                console.log('Impossibile validare, country vuoto')
                return true
            }
        }
        //Calcola codice fake
        const testingCF = helper.retrieveCheckCF(name, surname, dob, country, city);
        //Verifica la lunghezza cf attule:
        console.log('possible CF: ', testingCF);
        if (cf.length < 15) {
            console.log('Impossibile validare, cf troppo breve');
            return false;
        }
        const checkCF = cf.substring(0, 15).toUpperCase();
        const isValid = testingCF.reduce((carry, testVal) => {
            if (carry === true) {
                return carry;
            }
            if (testVal.substr(0, 15) === checkCF) {
                return true;
            }
            return carry;
        }, false);
        return isValid;
    },
    validateVAT: function (vat, country) {
        console.debug('richiesta convalida light di piva ', vat, country);
        if (typeof vat === 'undefined') {
            console.debug('Impossibile validare, vat nullo')
            return true
        }
        if (typeof country === 'undefined') {
            console.debug('Impossibile validare, country nullo')
            return true
        }
        const vatC = checkVAT(country.toUpperCase() + vat, countries);
        if (vatC) {
            return vatC.isValid;
        }
        return false;
    },
    validateForm: function (localForm) {

        const checkCF = helper.validateCF(
            localForm.querySelector(".field-cf input").value,
            localForm.querySelector(".field-name input").value,
            localForm.querySelector('.field-surname input').value,
            localForm.querySelector('.field-dob input').value,
            localForm.querySelector('.field-birth_country select').value,
            localForm.querySelector('.field-birth_city input').value
        );
        const checkVAT = helper.validateVAT(
            localForm.querySelector(".field-vat input").value,
            localForm.querySelector(".field-country select").value
        );
        const currentKind = $('input.kinds:checked').val();
        const vatIsMandatory = currentKind && currentKind !== 'private'
        console.log('verifica se cf, vat e mandatory sono validi', checkCF, checkVAT, currentKind, vatIsMandatory);
        let errors = [];
        const validateCFContainer = localForm.querySelector(".field-cf input").closest('span');
        const validateVATContainer = localForm.querySelector(".field-vat input").closest('span');
        validateCFContainer.classList.remove('mandatory-error');
        validateVATContainer.classList.remove('mandatory-error');
        if (!checkCF) {
            validateCFContainer.classList.add('mandatory-error');
            errors.push("Il codice fiscale inserito non è stato riconosciuto")
        }
        if (!checkVAT && vatIsMandatory) {
            validateVATContainer.classList.add('mandatory-error');
            errors.push("La partita iva inserita non è stata riconosciuta")
        }
        return errors;
    }
}

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, rawPos) {
            var pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

function enableSelectValidator() {
    const items = [...document.getElementsByClassName('select-jsvalidate')];
    const verifyOption = function (_option) {
        if (typeof _option === 'boolean') {
            return _option;
        }
        if (_option === 'true') {
            return true;
        }

        if (!_option) {
            return false;
        }
        const _optionfield = $('*[name=' + _option + ']');
        //If this optional was validated...check if has validation-error
        if (_optionfield.hasClass('validator-error')) {
            return false;
        }
        //If this optional is empty, is not optional
        if (!_optionfield.val() || (_optionfield.val() + "").length === 0) {
            return false;
        }
        //Ensure optional field was consumed
        if (_optionfield) {
            verifyField(_optionfield, _optionfield.parent(), false); //check if optional field is valid...
        }
        //check again if there are validation errors
        if (_optionfield.hasClass('validator-error')) {
            return false;
        }
        return true;
    };
    const verifyField = function (who, container, checkoptional) {
        const $this = $(who);
        container.removeClass("validator-error");
        container.removeClass("validator-warning");
        if (!container.hasClass('must-verify')) {
            return;
        }
        const validator = container.data('validator');
        let _isOptional = false;
        const _value = $this.val();

        let isValid = false;
        if (validators[validator]) {
            isValid = validators[validator](_value);
        }
        if (checkoptional) {
            _isOptional = verifyOption(container.data('optional'));
        }
        if (!isValid) {
            if (!isValid && !_isOptional) {
                container.addClass("validator-error");
            }
            if (!isValid && _isOptional) {
                container.addClass("validator-warning");
            }
        }
    };
    items.map((item, idx) => {
        const $item = $(item);
        const $input = $(item.querySelector('select'));
        const _dataCondition = $item.data('condition');
        if (_dataCondition) {
            //Add rule only when data condition is satisfied
            $("*[name=" + _dataCondition.field).on('change', function (e) {
                $item.removeClass('must-verify');
                if (this.value === _dataCondition.value) {
                    $item.addClass('must-verify');
                    $input.trigger('blur');
                }
            });
            const startValue = $("*[name=" + _dataCondition.field).val();
            if (startValue) {
                if (startValue === _dataCondition.value) {
                    $item.addClass('must-verify');
                    $input.trigger('blur');
                }
            }
        } else {
            //Without condition, add rule by default
            $item.addClass('must-verify');
        }
        $(item.closest('form')).on('submit', function (e) {
            console.log('convalida form prima dell\'invio');
            //Before submit validate all the form objects:
            [...this.querySelectorAll(".select-jsvalidate.must-verify")].map((item) => {
                item.classList.remove("validation-error");
                verifyField(item.querySelector('select'), $(item), true);
            });
            //Check if there are Errors or not...
            const hasError = this.querySelector(".select-jsvalidate.must-verify.validator-error");
            if (hasError) {
                hasError.focus({preventScroll: false});
                e.preventDefault();
                e.stopPropagation();
                toastr.error('Verifica che tutti i campi siano compilati correttamente', 'Impossibile salvare', {preventDuplicates: true});
                return;
            }
            return true;
        });
        $input.on('blur', function (e) {
            verifyField(this, $item, true);
        });
        $input.on('select2:select', function (e) {
            verifyField(this, $item, true);
        });
        $input.on('forcevalidate', function (e, newvalue) {
            if (newvalue) {
                this.value = newvalue;
            }
            verifyField(this, $(this.closest('.select-jsvalidate')), true);
        })
        verifyField($input, $item, true);
    });
    window.selectValidatorRevalidate = function (form) {
        [...form.querySelectorAll(".select-jsvalidate.must-verify")].map((item) => {
            item.classList.remove("validation-error");
            verifyField(item.querySelector('select'), $(item), true);
        });
        //Check if there are Errors or not...
        const hasError = form.querySelector(".select-jsvalidate.must-verify.validator-error");
        return hasError;
    }

}

function enableTextValidator() {
    const items = [...document.getElementsByClassName('text-jsvalidate')];
    const verifyOption = function (_option) {
        if (typeof _option === 'boolean') {
            return _option;
        }
        if (_option === 'true') {
            return true;
        }

        if (!_option) {
            return false;
        }
        const _optionfield = $('*[name=' + _option + ']');
        //If this optional was validated...check if has validation-error
        if (_optionfield.hasClass('validator-error')) {
            return false;
        }
        //If this optional is empty, is not optional
        if (!_optionfield.val() || (_optionfield.val() + "").length === 0) {
            return false;
        }
        //Ensure optional field was consumed
        if (_optionfield) {
            verifyField(_optionfield, _optionfield.parent(), false); //check if optional field is valid...
        }
        //check again if there are validation errors
        if (_optionfield.hasClass('validator-error')) {
            return false;
        }
        return true;
    };
    const verifyField = function (who, container, checkoptional) {
        const $this = $(who);
        container.removeClass("validator-error");
        container.removeClass("validator-warning");
        if (!container.hasClass('must-verify')) {
            return;
        }
        const validator = container.data('validator');
        let _isOptional = false;
        const _value = $this.val() || who.value;

        let isValid = false;
        if (validators[validator]) {
            isValid = validators[validator](_value);
        }
        if (checkoptional) {
            _isOptional = verifyOption(container.data('optional'));
        }
        if (!isValid) {
            if (!isValid && !_isOptional) {
                container.addClass("validator-error");
            }
            if (!isValid && _isOptional) {
                container.addClass("validator-warning");
            }
        }
    };
    items.map((item, idx) => {
        const $item = $(item);
        const $input = $(item.querySelector('input'));
        const _dataCondition = $item.data('condition');

        if (_dataCondition) {
            //Add rule only when data condition is satisfied
            $("*[name=" + _dataCondition.field).on('change', function (e) {
                $item.removeClass('must-verify');
                if (this.value === _dataCondition.value) {
                    $item.addClass('must-verify');
                    $input.trigger('blur');
                }
            });
            const startValue = $("*[name=" + _dataCondition.field).val();
            if (startValue) {
                if (startValue === _dataCondition.value) {
                    $item.addClass('must-verify');
                    $input.trigger('blur');
                }
            }
        } else {
            //Without condition, add rule by default
            $item.addClass('must-verify');
        }
        $(item.closest('form')).on('submit', function (e) {
            //Before submit validate all the form objects:
            [...this.querySelectorAll(".text-jsvalidate.must-verify")].map((item) => {
                item.classList.remove("validation-error");
                verifyField(item.querySelector('input'), $(item), true);
            });
            //Check if there are Errors or not...
            const hasError = this.querySelector(".text-jsvalidate.must-verify.validator-error");
            if (hasError) {
                hasError.focus({preventScroll: false});
                e.preventDefault();
                e.stopPropagation();
                toastr.error('Verifica che tutti i campi siano compilati correttamente', 'Impossibile salvare', {preventDuplicates: true});
                return;
            }
        });
        $input.on('blur', function (e) {
            verifyField(this, $item, true);
        });
        $input.on('forcevalidate', function (e, newvalue) {
            if (newvalue) {
                this.value = newvalue;
            }
            verifyField(this, $(this.closest('.text-jsvalidate')), true);
        })
        verifyField($input, $item, true);
    });
    window.textValidatorRevalidate = function (form) {
        [...form.querySelectorAll(".text-jsvalidate.must-verify")].map((item) => {
            item.classList.remove("validation-error");
            verifyField(item.querySelector('input'), $(item), true);
        });
        //Check if there are Errors or not...
        const hasError = form.querySelector(".text-jsvalidate.must-verify.validator-error");
        return hasError;
    }

}

function enableSelect2Related() {
    const selects = [...document.getElementsByClassName('selectable')];

    const triggerAjax = function (url, destination, onupdate) {
        fetch(url + "?select2=1")
            .then((response) => {
                return response.json();
            }).then((jsonData) => {
            let select2Options = {
                width: '100%',
                placeholder: "Scegli un valore dall'elenco",
                data: jsonData
            };
            if ($(destination).data('minchars')) {
                select2Options['minimumInputLength'] = $(destination).data('minchars');
                //In questo caso mettiamo il matcher per "inizia per":
                select2Options['matcher'] = function (params, data) {
                    if ($.trim(params.term) === '') {
                        return null;
                    }
                    if (typeof data.text === 'undefined') {
                        return null;
                    }

                    if (data.text.toLowerCase().startsWith(params.term.toLowerCase())) {
                        return data;
                    }
                    return null;
                };
            }
            $(destination).select2(select2Options);
            $(destination).on('select2:select', function (e) {
                var data = e.params.data;
                if (data.id == '') {
                    // "None" was selected. Clear all selected options
                    $(this).val([]).trigger('change');
                } else {
                    $(e.currentTarget).find("option[value='" + data.id.replace(/'/g, "\\'") + "']").attr('selected', 'selected');
                }
                if (destination.closest('div.text-jsvalidate')) {
                    const closerValidator = destination.closest('div.text-jsvalidate').querySelector('input');
                    $(closerValidator).trigger('forcevalidate', [e.params.data.id]);
                }
                destination.dataset.preselect = e.params.data.id;
                onupdate(e.params.data.id);
            })
            if (destination.dataset && destination.dataset.preselect) {
                setTimeout(function (dest, callback) {
                    $(dest).val(dest.dataset.preselect).trigger('change');
                    callback(dest.dataset.preselect);
                }, 50, destination, onupdate);
            } else {
                $(destination).val(null).trigger('change');
                onupdate(null);
            }
        });

    };
    const setupAutocompleteAndLoad = function (url, destination, triggerItem) {
        if (triggerItem.closest('div.text-jsvalidate')) {
            $(triggerItem).trigger('forcevalidate');
        }
        if (triggerItem) {
            if (triggerItem.dataset && triggerItem.dataset.initialValue) {
                destination.dataset.preselect = triggerItem.dataset.initialValue;
            }
        }
        const onupdate = function (newdata) {
            triggerItem.value = newdata;
            $(triggerItem).trigger('change');
        }
        const minChars = destination.dataset.minchars ?? 2;
        let select2Options = {
            width: '100%',
            minimumInputLength: minChars,
            placeholder: "Inserisci almeno " + minChars + " per iniziare la ricerca",
            language: 'it',
            ajax: {
                delay: 250,
                url: url,
                data: function (params) {
                    var query = {
                        q: params.term,
                        page: params.page || 1
                    }
                    return query;
                }
            }
        };

        $(destination).select2(select2Options);
        $(destination).on('select2:select', function (e) {
            var data = e.params.data;
            if (data.id == '') {
                // "None" was selected. Clear all selected options
                $(this).val([]).trigger('change');
            } else {
                $(e.currentTarget).find("option[value='" + data.id.replace(/'/g, "\\'") + "']").attr('selected', 'selected');
            }
            if (destination.closest('div.text-jsvalidate')) {
                const closerValidator = destination.closest('div.text-jsvalidate').querySelector('input');
                $(closerValidator).trigger('forcevalidate', [e.params.data.id]);
            }
            destination.dataset.preselect = e.params.data.id;
            onupdate(e.params.data.id);
        })

        if (destination.dataset && destination.dataset.preselect) {
            setTimeout(function (dest, callback) {
                $(dest).val(dest.dataset.preselect).trigger('change');
                callback(dest.dataset.preselect);
            }, 50, destination, onupdate);
        } else {
            $(destination).val(null).trigger('change');
            onupdate(null);
        }
    };
    const checkValueAndLoad = function (url, destination, triggerItem) {
        if (triggerItem.closest('div.text-jsvalidate')) {
            $(triggerItem).trigger('forcevalidate');
        }
        if (triggerItem) {
            if (triggerItem.dataset && triggerItem.dataset.initialValue) {
                destination.dataset.preselect = triggerItem.dataset.initialValue;
            }
        }
        triggerAjax(url, destination, function (newdata) {
            triggerItem.value = newdata;
            $(triggerItem).trigger('change');
        });
    }
    const tranformInputToSelect = function (destination, revert) {
        const $destination = $(destination);
        const _dataAjaxLoader = $destination.data('ajax-loader');
        const _dataAttrRelated = $destination.data('related-field');
        const _dataAttrRelatedV = $destination.data('activate-value');
        const _minchars = $destination.data('minchars') || false;
        const $inputItem = destination.querySelector('input');
        const $selectItem = destination.querySelector('select');
        if (_minchars !== false) {
            $selectItem.dataset.minchars = _minchars;
            $inputItem.dataset.minchars = _minchars;
        }
        $destination.removeClass('select2_active');
        if (revert) {
            $($selectItem).off('select2:select');
            if ($($selectItem).hasClass("select2-hidden-accessible")) {
                $($selectItem).select2('destroy');
            }
            $($selectItem).css('display', 'none');
            $($inputItem).css('display', 'inherit');
        } else {
            $destination.addClass('select2_active');
            $($selectItem).css('display', 'inherit');
            $($inputItem).css('display', 'none');
            let _exactMatch = _dataAttrRelatedV === 'CURRENT' ? false : true;
            if (_dataAttrRelated) {
                $("*[name=" + _dataAttrRelated).on('change', function (e) {
                    if (!$destination.hasClass('select2_active')) {
                        return; //Quit select2 is not active
                    }
                    let url = "";
                    if (_exactMatch && _dataAttrRelatedV === this.value && this.value.length > 0) {
                        url = _dataAjaxLoader;
                    } else if (_dataAttrRelatedV.length > 0 && this.value.length > 0) {
                        url = _dataAjaxLoader.replace("{" + _dataAttrRelatedV + "}", this.value);
                    }
                    if (url.length > 0) {
                        if ($selectItem.classList.contains("select2withautocomplete")) {
                            console.log('gestisci la versione con autocomplete')
                            setupAutocompleteAndLoad(url, $selectItem, $inputItem);
                        } else {
                            checkValueAndLoad(url, $selectItem, $inputItem);
                        }
                    }
                });
                let url = "";
                const testValue = $("*[name=" + _dataAttrRelated).val();
                if (_exactMatch === true && _dataAttrRelatedV === testValue && testValue.length > 0) {
                    //Attiva valore uguale:
                    url = _dataAjaxLoader;
                } else if (_dataAttrRelatedV.length > 0 && testValue.length > 0) {
                    url = _dataAjaxLoader.replace("{" + _dataAttrRelatedV + "}", testValue);
                }
                if (url.length > 0) {
                    if ($selectItem.classList.contains("select2withautocomplete")) {
                        console.log('gestisci la versione con autocomplete')
                        setupAutocompleteAndLoad(_dataAjaxLoader, $selectItem, $inputItem);
                    } else {
                        checkValueAndLoad(_dataAjaxLoader, $selectItem, $inputItem);
                    }
                }
            }
        }
    };
    selects.map((item, idx) => {
        const $item = $(item);
        const $inputItem = item.querySelector('input');
        const $selectItem = item.querySelector('select');
        const _dataCondition = $item.data('condition');
        const _dataAjaxLoader = $item.data('ajax-loader');
        const _dataAttrRelated = $item.data('related-field');
        const _dataAttrRelatedV = $item.data('activate-value');

        if ($inputItem) {
            $inputItem.dataset.placeholder = $inputItem.placeholder || "";
            const startValue = $inputItem.value;
            if (typeof startValue !== 'undefined' && (startValue + "").length >= 0) {
                $inputItem.dataset.initialValue = startValue;
            }
        }
        $($selectItem).css('display', 'none');
        if (_dataCondition) {

            const relatedField = $("*[name=" + _dataCondition.field);
            $inputItem.dataset.related_placeholder = "Scegli prima un valore dall'elenco";
            if (relatedField) {
                $inputItem.dataset.related_placeholder = "Scegli prima un valore da " + relatedField.data('label');
            }

            relatedField.on('change', function (e) {
                if((this.value+"").length>0) {
                    $inputItem.readOnly = false;
                    $inputItem.placeholder = $inputItem.dataset.placeholder;
                } else {
                    $inputItem.placeholder = $inputItem.dataset.related_placeholder;
                    $inputItem.readOnly = true;
                }
                tranformInputToSelect(item, this.value !== _dataCondition.value);
            });
            const startValue = relatedField.val();
            if (startValue) {
                $inputItem.readOnly = false;
                $inputItem.placeholder = $inputItem.dataset.placeholder;
                tranformInputToSelect(item, startValue !== _dataCondition.value);
            } else {
                $inputItem.placeholder = $inputItem.dataset.related_placeholder;
                $inputItem.readOnly = true;
            }
        }
    });
}


document.addEventListener('DOMContentLoaded', function () {
    if (toastr && typeof toastr !== 'undefined') {
        toastr.options.preventDuplicates = true;
    }
    $.fn.select2.defaults.set('language', "it");
    $('select.select2').select2({width: '100%'});
    enableSelect2Related();
    enableTextValidator();
    enableSelectValidator();
    /*Fix for select2 issue */
    $(document).on('select2:open', (e) => {
        const selectId = e.target.id;
        $(".select2-search__field[aria-controls='select2-"+selectId+"-results']").each(function (key,value,){
            value.focus();
        });
    });

});


const validators = {
    "italy_cap": function (v) {
        return /^\d{5}$/.test(v);
    },
    "italy_cf": function (v) {
        return /^[a-zA-Z]{6}\d\d[a-zA-Z]\d\d[a-zA-Z]\d\d\d[a-zA-Z]/.test(v);
    },
    "italy_vat": function (v) {
        return /^(IT)?\d{11}$/.test(v);
    },
    "italy_sdi": function (v) {
        if (v === '999999') {
            //check code for fake sdi
            return true;
        }
        if (v === '0000000') {
            return true;
        }
        return /^[a-zA-Z0-9]{6,7}$/.test(v);
    },
    "email": function (v) {
        return /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(v);
    },
    "notempty": function (v) {
        return typeof v !== 'undefined' && (v + "").length > 0;
    },
    "digits": function (v) {
        return /^(0|[1-9]\d*)(\.\d+)?$/.test(v)||/^(0|[1-9]\d*)(,\d+)?$/.test(v);
    },
    "integer": function (v) {
        return /^(0|[1-9]\d*)$/.test(v);
    }
}

window.helper = helper;
